import React, { useState, useEffect } from 'react'

import ReservationWidget from '../../shared/ReservationWidget'

import { parseStyles } from '@reactiveonline/reactive_builder_parser/parser'

export default function ServiceBooking({ item, deviceType, extraData }) {
  const { settings } = item
  const { id, classes, text, headingType, styles, headingStyles } = settings
  const appProps = extraData
  const Element = headingType

  return (
    <div
      id={ id || item.id }
      className={ `rb-service-booking ${ classes || '' }` }
      style={ parseStyles(styles, deviceType) }
    >
      { text &&
        <Element
          style={ parseStyles(headingStyles, deviceType, { themeSettingsSeedData: [{ themeSettingKey: headingType }] }) }
        >
          { text }
        </Element>
      }

      <ReservationWidget
        appProps={ appProps }
        actionText={ appProps.translations.reservations.add_to_cart }
        disableFormStyles
      />
    </div>
  )
}
